import { PlannerTaskRelation } from '@vision/ui/interfaces';
import { PlannerTaskRelationType } from '@vision/ui/enums';

type StoredTaskRelation = Partial<PlannerTaskRelation> & {
  object_id?: string;
  object_type?: PlannerTaskRelationType;
  object?: PlannerTaskRelation['record'];
};

const LAST_SELECTED_BOARD_ID_KEY = 'lastSelectedBoardId';
const TASK_RELATION_TO_ADD_KEY = 'taskRelationToAdd';

export function setLastSelectedBoardId(boardId: string) {
  localStorage.setItem(LAST_SELECTED_BOARD_ID_KEY, boardId);
}

export function getLastSelectedBoardId() {
  return localStorage.getItem(LAST_SELECTED_BOARD_ID_KEY);
}

// Names have fromLocalStorage suffix to avoid confusion with same-named planner state object
export function getTaskRelationToAddFromLocalStorage(): PlannerTaskRelation | null {
  try {
    const value = localStorage.getItem(TASK_RELATION_TO_ADD_KEY);
    if (!value) return null;

    const stored: StoredTaskRelation = JSON.parse(value);
    if (!stored || typeof stored !== 'object') return null;

    // Older Inbox builds can still leave the previous relation format in storage.
    const { object_id, object_type, object, ...relation } = stored;
    const recordId = relation.record_id ?? object_id;
    const recordType = relation.record_type ?? object_type;
    if (typeof recordId !== 'string' || !recordId || !Object.values(PlannerTaskRelationType).includes(recordType)) {
      return null;
    }

    return {
      ...relation,
      record_id: recordId,
      record_type: recordType,
      record: relation.record ?? object,
    };
  } catch (error) {
    console.error('Failed to parse task relation from localStorage:', error);
    localStorage.removeItem(TASK_RELATION_TO_ADD_KEY);
    return null;
  }
}

export function removeTaskRelationToAddFromLocalStorage() {
  localStorage.removeItem(TASK_RELATION_TO_ADD_KEY);
}
